import React from 'react';

export const LightBeam = ({ className }: { className?: string }) => {
  const animate = false;

  return (
    <svg
      className={className}
      width={'110%'}
      height={'100%'}
      viewBox="0 0 1016 619"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1016 0H0L503 650H574.5L1016 0Z" fill="url(#paint0_radial)" />
      <defs>
        {animate ? (
          <radialGradient id="paint0_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFEDAB" />
            <stop offset="1" stopColor="#F7FF9F" stopOpacity="0" />
            <animateTransform
              attributeName="gradientTransform"
              attributeType="XML"
              dur="3000ms"
              type="translate"
              calcMode="linear"
              values="538, 500;539, 550;539, 620;539, 630;539, 620;538, 550;539, 500"
              repeatCount="indefinite"
              additive="sum"
              fill="freeze"
            />
            <animateTransform
              attributeName="gradientTransform"
              attributeType="XML"
              dur="1m"
              type="rotate"
              values="-107.447"
              repeatCount="indefinite"
              additive="sum"
            />
            <animateTransform
              attributeName="gradientTransform"
              attributeType="XML"
              dur="1m"
              type="scale"
              values="623.694,1020.95"
              repeatCount="indefinite"
              additive="sum"
            />
          </radialGradient>
        ) : (
          <radialGradient
            id="paint0_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(538 539) rotate(-107.447) scale(623.694 1020.95)"
          >
            <stop stopColor="#FFEDAB" />
            <stop offset="1" stopColor="#F7FF9F" stopOpacity="0" />
          </radialGradient>
        )}
      </defs>
    </svg>
  );
};
